export default __webpack_public_path__ + "static/media/bg-b.6ec50a3a.png";